module.exports = __webpack_public_path__ + "img/11.7347d170.jpeg";